import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageTitle: {
		id: 'directories.dashboards-v2.page.page-title',
		defaultMessage: 'Dashboards',
		description: 'Dashboards directory page title',
	},
});
